/** `?page=` as a page number: a positive integer, anything else is page 1. No imports, so client components can use it. */
export function pageFromParam(raw: string | string[] | null | undefined): number {
  const s = Array.isArray(raw) ? raw[0] : raw
  return s && /^[1-9]\d*$/.test(s) ? Number(s) : 1
}
